import * as React from 'react';
import { Field, reduxForm, change } from 'redux-form';
//import DEform from '../forms/DEform';
import styles from './deFormStyles';
import { TouchableOpacity } from 'react-native';
import {
	Container,
	Header,
	InputGroup,
	Content,
	Text,
	Label,
	Picker,
	Item,
	Card,
	CardItem,
	Input,
	Icon,
	Toast,
	Form,
	Spinner,
	View,
	Left,
	Right,
	Body,
	Button,
	Title,
	H3,
	Separator
} from 'native-base';
import BusTypeContainer from '../screens/Signup/busTypeContainer';

//import * as _ from 'lodash';

import customValidate from './validators';

import { textInput, moneyInput, renderPicker, renderDateField, renderCheckbox, renderSwitch, renderAutoComplete } from './renderedComponents';

const upper = value => value && value.toUpperCase();
const mustBePresent = value => (value ? undefined : 'Required');

function signUpSyncValidate(values, props) {
	//runs while field changing
	const errors = {};

	//if(parseFloat(values.paid)>0 && values.account_id==0) errors.account_id='Please select an account';

	return errors;
}

function signUpAsyncValidate(values, dispatch, props, field) {
	return new Promise((resolve, reject) => {
		if (field == 'startYear') dispatch(change('SignUpForm', 'accountingStartDate', values[field] ? '2019-04-06' : '2020-04-06'));
		//console.log('changing', 'accountingStartDate', values[field] ? '2019-04-06' : '2020-04-06');
		/*
			//runs on BLUR for net, vat, payable, paid. So first update values
			var value= Number(values[field]);
			var Dispval = parseFloat(isNaN(value)?0:value).toFixed(2);
			console.log('changing ', field, Dispval);
			dispatch(change('SignUpForm', field, Dispval));
			*/
		resolve();
	});
}

class SignUpForm extends React.Component {
	constructor(props) {
		super(props);

		this.initialState = {};
		this.state = this.initialState;
		this.formRefs = [];
	}

	componentWillReceiveProps(nextProps) {}

	_changeFormVal(field, val) {
		__DEV__ && console.log('setting ', field, val);
		this.props.dispatch(change('SignUpForm', field, val));
	}

	render() {
		const { handleSubmit, pristine, reset, submitting, invalid, defaultDate } = this.props;
		const y = defaultDate.split('-', 1)[0];
		const lastYear = `20${y - 2001}-${y - 2000}`;
		const thisYear = `20${y - 2000}-${y - 1999}`;
		/*
			Bus Type, VATreg, level -> eg https://calcal.uk/membership-account/membership-checkout/?level=2&busid=5
			That asks for username, password, email, name, mobile, vatreg, taxtype=ldt/se, startDate, Terms


			*/

		return (
			<View style={{ flex: 1, padding: 0 }}>
				<Form onSubmit={this.props.handleSubmit}>
					<Card>
						<Separator>
							<H3>🔧 About Your Business</H3>
						</Separator>
						<CardItem style={{ width: '100%', flexDirection: 'column', alignItems: 'stretch' }}>
							<Field
								name="busid"
								// style={{ flex: 1 }}
								title="What Kind of Business?"
								label="Business"
								labelWidth={120} //cant find that 16 and 5 padding!!
								buttonText="Find your business type"
								component={BusTypeContainer}
								data={this.props.busTypes}
							/>
							<Field name="company" labelType="inline" labelWidth={120} label="Name" validate={[mustBePresent]} placeholder="Company Name" component={textInput} />

							<Field name="taxtype" labelType="fixed" label="Tax Type" onVal="Ltd Company" offVal="Self-Employed" component={renderSwitch} />

							{this.props.isLtd && (
								<Field
									name="accountingPeriod"
									label="Accounting Period Start"
									validate={[mustBePresent]}
									labelType="inline"
									labelWidth={200}
									placeholder=" This Year's Start"
									noIcon
									component={renderDateField}
								/>
							)}
							<Field name="vatreg" labelType="inline" label="VAT Registered" component={renderSwitch} />
							<Field name="lumpUp" labelType="inline" label="Enter past transactions" onVal="Totals up to:" offVal="From start of tax year" component={renderSwitch} />
							{this.props.isLump && <Field name="accountingStartDate" label="Totals Up To" noIcon labelType="inline" labelWidth={200} placeholder="Start Date" component={renderDateField} />}
							{!this.props.isLump && !this.props.isLtd && <Field name="startYear" label="Start From" onVal={lastYear} offVal={thisYear} component={renderSwitch} />}
						</CardItem>
					</Card>
					<Card>
						<Separator>
							<H3>👷 About You</H3>
						</Separator>
						<CardItem>
							<Body>
								<Field name="name" labelWidth={120} labelType="inline" label="Name" placeholder="Your Name" validate={[mustBePresent]} component={textInput} />
								<Field name="username" labelWidth={120} labelType="inline" label="Username" validate={[mustBePresent]} placeholder="Choose a username" component={textInput} />
								<Field name="password" labelWidth={120} labelType="inline" label="Password" validate={[customValidate, mustBePresent]} secureTextEntry component={textInput} />
							</Body>
						</CardItem>

						<Separator>
							<H3>📞 Contact</H3>
						</Separator>
						<CardItem bordered>
							<Body>
								<Field
									name="mobile"
									labelType="inline"
									validate={[customValidate, mustBePresent]}
									keyboardType={'phone-pad'}
									label="Mobile Number"
									component={textInput}
									placeholder="Non-UK? Include country code"
								/>
								<Field name="email" labelType="inline" validate={[customValidate, mustBePresent]} keyboardType={'email-address'} label="Email" component={textInput} />
							</Body>
						</CardItem>
					</Card>
					<Button padder full disabled={invalid || submitting || pristine} onPress={this.props.handleSubmit}>
						<Text>Submit</Text>
						{submitting && <Spinner />}
					</Button>
				</Form>
			</View>
		);
	}
}

export default reduxForm({
	form: 'SignUpForm',
	validate: signUpSyncValidate,
	asyncValidate: signUpAsyncValidate,
	asyncBlurFields: ['startYear'] //cause a re-render
})(SignUpForm);
